 <!--page starts-->
 <section class="page-wrapper">
    <div class="fixture-season-section margin-top-152 cf">
        <div class="container">
            <div class="buyticket-title">
                <div class="titel-box">
                    <h2 class="titel-name">Buy Tickets</h2>
                </div>
            </div>
            <div class="fixture-season-detail">
                <ul>
                    <li>
                        <a href="javascript:void(0)" class="season-top">
                            <!-- <ul class="fixture-season-list">
                                <li><a href="javascript:void(0)">2020 Season</a></li>
                                <li><a href="javascript:void(0)">2020 Season</a></li>
                                <li><a href="javascript:void(0)">2020 Season</a></li>
                            </ul> -->
                            <select class="select_tab">   
                                <optgroup>                        
                                    <option value="{{season?.season_type_id}}" class="{{i}}" *ngFor="let season of seasonList?.data; let i = index">{{season?.title}} Season</option>
                                </optgroup>     <!-- <option value="1">2020 Season</option>
                                    <option value="2">2019 Season</option> -->
                                 
                            </select>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
            <div class="fixture-season-tab-section cf">
                    <div class="fixture-season-tab-detail">
                        <ul class="maintab">
                            <li class="courses-name " [ngClass]="{ active: i == 0 }" id="tab-{{season?.series_type_id}}" *ngFor="let season of seasontypeList?.series_type; let i = index"><a href="javascript:void(0)" id="{{season?.series_type_id}}">{{season?.title}}</a></li>
                            <!-- <li class="courses-name " id="vitality-blast"><a href="#">Vitality Blast</a></li>
                            <li class="courses-name " id="university-match"><a href="#">University Match</a></li>
                            <li class="courses-name " id="tourist-t20"><a href="#">Tourist T20</a></li>
                            <li class="courses-name active" id="bob-willis"><a href="#">Bob Willis Trophy </a></li>
                            <li class="courses-name " id="county-championship"><a href="#">County Championship</a></li>
                            <li class="courses-name " id="national-country"><a href="#">National Country</a></li>
                            <li class="courses-name " id="royal-london-cap"><a href="#">Royal London Cap</a></li> -->
                        </ul>
                    </div>
                    <div class="fixture-season-tab-content-detail course-main-content  cf" [ngClass]="{ active: i == 0 }" id="tab-{{season?.series_type_id}}-content" *ngFor="let season of seasontypeList?.series_type; let i = index">
                        <div class="container">
                           <div class="fixture-season-tab-content-top">
                               <div class="fixture-season-tab-celender">
                                    <div class="celender-box">
                                        <div class="row text-center">
                                            <div class="col-md-4">
                                                <div class="btn-group">
                                                    <div class="btn btn-primary Previous" mwlCalendarPreviousView [view]="view"
                                                        [(viewDate)]="viewDate" (viewDateChange)="closeOpenMonthViewDay()">
            
                                                    </div>
                                                    <div class="btn btn-outline-secondary" mwlCalendarToday [(viewDate)]="viewDate">
            
                                                    </div>
                                                    <div class="btn btn-primary next" mwlCalendarNextView [view]="view"
                                                        [(viewDate)]="viewDate" (viewDateChange)="closeOpenMonthViewDay()">
            
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="month-name">
                                                <h3>{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}</h3>
                                            </div>
                                            <div class="calendarmenu">
                                                <ul>
                                                    <li class="menu-team-top">
                                                        <a href="#">Add To Calender</a>                                      
                                                    </li>
                                                </ul> 
                                            
                                            </div>
                                        </div>
                                        <br />
                                        <div [ngSwitch]="view" class="date-menu">
                                            <mwl-calendar-month-view *ngSwitchCase="CalendarView.Month" [viewDate]="viewDate"
                                                [events]="events" [refresh]="refresh" [activeDayIsOpen]="activeDayIsOpen"
                                                (dayClicked)="dayClicked($event.day)"
                                                (eventClicked)="handleEvent('Clicked', $event.event)"
                                                (eventTimesChanged)="eventTimesChanged($event)">
                                            </mwl-calendar-month-view>
                                            <mwl-calendar-week-view *ngSwitchCase="CalendarView.Week" [viewDate]="viewDate"
                                                [events]="events" [refresh]="refresh"
                                                (eventClicked)="handleEvent('Clicked', $event.event)"
                                                (eventTimesChanged)="eventTimesChanged($event)">
                                            </mwl-calendar-week-view>
                                            <mwl-calendar-day-view *ngSwitchCase="CalendarView.Day" [viewDate]="viewDate"
                                                [events]="events" [refresh]="refresh"
                                                (eventClicked)="handleEvent('Clicked', $event.event)"
                                                (eventTimesChanged)="eventTimesChanged($event)">
                                            </mwl-calendar-day-view>
                                        </div>
                                    </div>
                               </div>
                               <div class="fixture-season-tab-matches">
                                   <div class="second-fixtures-detail-tab">
                                        <div class="second-fixtures-detail-tab-list">
                                            <ul class="subtab">
                                               <li class="fixtures-name ok" id="upcoming-matches"><a href="#" id="Upcoming">Upcoming Matches</a></li>
                                               <li class="fixtures-name " id="past-matches"><a href="#" id="Past">Past Matches</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="second-fixtures-detail-tab-detail fixtures-main-content ok" id="upcoming-matches-content">
                                         <div class="leicester-match-section cf">
                                            <ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slidematchbookConfig">
                                                <div ngxSlickItem class="leicester-match-box-slide slide cf" *ngFor="let upcoming of matchesList?.data; let i = index">
                                                    <div class="leicester-match-box" >
                                                        <div class="leicester-match-box-left">
                                                            <div class="leicester-match-box-left-logo-box">
                                                                <div class="leicester-match-left">
                                                                    <img [src]="upcoming?.first_image">
                                                                </div>
                                                                <div class="leicester-match-center">
                                                                    <h2>vs</h2>
                                                                </div>
                                                                <div class="leicester-match-right">
                                                                    <img [src]="upcoming?.second_image">
                                                                </div>
                                                            </div>
                                                            <div class="leicester-match-box-left-content">
                                                                <h4>{{upcoming?.location}}</h4>
                                                                <p>{{upcoming?.date_time | amDateFormat: "DD MMM YYYY,"}} Starts {{upcoming?.date_time | amDateFormat: "HH:mm"}}</p>
                                                            </div>
                                                        </div>
                                                        <div class="leicester-match-box-right">
                                                            <div class="leicester-match-box-right-btn">
                                                                <a href="javascript:void(0)">Book Tickets</a>
                                                            </div>
                                                        </div>
                                                        <div class="leicester-match-overlay"></div>
                                                    </div>
                                                </div>
                                            </ngx-slick-carousel>
                                        </div>
                                    </div>
                                    <div class="second-fixtures-detail-tab-detail fixtures-main-content " id="past-matches-content">
                                         <div class="leicester-match-section cf">
                                            <ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slidematchreportConfig">
                                                <div ngxSlickItem class="leicester-match-box-slide slide cf" *ngFor="let past of matchesList?.data; let i = index">
                                                    <div class="leicester-match-box" >
                                                        <div class="leicester-match-box-left">
                                                            <div class="leicester-match-box-left-logo-box">
                                                                <div class="leicester-match-left">
                                                                    <img [src]="past?.first_image">
                                                                </div>
                                                                <div class="leicester-match-center">
                                                                    <h2>vs</h2>
                                                                </div>
                                                                <div class="leicester-match-right">
                                                                    <img [src]="past?.second_image">
                                                                </div>
                                                            </div>
                                                            <div class="leicester-match-box-left-content">
                                                                <h4>{{past?.location}}</h4>
                                                                <p>{{past?.date_time | amDateFormat: "DD MMM YYYY,"}} Starts {{past?.date_time | amDateFormat: "HH:mm"}}</p>
                                                            </div>
                                                        </div>
                                                        <div class="leicester-match-box-right">
                                                            <div class="leicester-match-box-right-btn">
                                                                <a href="javascript:void(0)">Book Tickets</a>
                                                            </div>
                                                        </div>
                                                        <div class="leicester-match-overlay"></div>
                                                    </div>
                                                </div>
                                            </ngx-slick-carousel>
                                        </div>
                                    </div>
                               </div>
                           </div>
                           
                       </div>
                    </div>
            </div>
        
    </div>
</section><!-- page ends-->
